export default {"src":"/app/membership/_next/static/media/carousel-cat.2ff34c33.svg","height":180,"width":222,"blurWidth":0,"blurHeight":0};